import * as i0 from "@angular/core";
export class TooltipModule {
}
TooltipModule.ɵfac = function TooltipModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TooltipModule)(); };
TooltipModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TooltipModule });
TooltipModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
